<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div class="flex flex-auto justify-center w-full sm:p-4 md:p-6 bg-accent dark:bg-card">

    <!-- Navigation -->
    <ng-container *ngIf="isScreenSmall">
        <fuse-vertical-navigation
            class="dark bg-gray-900 print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex justify-center p-2 mb-2 dark:bg-accent">
                    <img class="w-18" src="assets/images/logo/tecsa_logo_nuevo.png" alt="Logo image">
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    </ng-container>

    <!-- Wrapper -->
    <div class="flex flex-col items-center flex-auto min-w-0 max-w-360 sm:rounded-xl shadow-2xl dark:shadow-none overflow-hidden">

        <!-- Header -->
        <div class="relative flex flex-0 items-center w-full h-16 sm:h-24 px-4 md:px-6 z-49 bg-card border-b dark:bg-primary-900 print:hidden">
            <ng-container *ngIf="!isScreenSmall">
                <!-- Logo -->
                <div class="flex items-center mx-2 lg:mr-8">
                    <div class="flex justify-center p-2 rounded-full">
                            <img class="w-18" src="assets/images/logo/tecsa_logo_nuevo.png" alt="Logo image">
                    </div>
                </div>
                <!-- Horizontal navigation -->
                <fuse-horizontal-navigation
                    class="mr-2"
                    [name]="'mainNavigation'"
                    [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
            </ng-container>
            <!-- Navigation toggle button -->
            <ng-container *ngIf="isScreenSmall">
                <button
                    class="mr-2"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                </button>
                <div class="flex items-center mx-2 lg:mr-8">
                    <div class="flex justify-center p-2 rounded-full">
                            <img class="w-18" src="assets/images/logo/tecsa_logo_nuevo.png" alt="Logo image">
                    </div>
                </div>
            </ng-container>
            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-1 sm:space-x-2">
                <search [appearance]="'bar'"></search>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <button mat-icon-button (click)="changeScheme(config.scheme === 'dark' ? 'light' : 'dark')">
                    <mat-icon [svgIcon]="config.scheme === 'dark' ? 'heroicons_outline:moon' : 'heroicons_outline:sun'"></mat-icon>
                </button>
                <ng-container *ngIf="hasUser">
                    <user></user>
                </ng-container>
                <ng-container *ngIf="!hasUser">
                    <a
                    class="ml-1 text-primary-500 hover:underline"
                    [routerLink]="['/sign-in']">Registrarse
                    </a>
                </ng-container>
            </div>
            </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto w-full bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Footer -->
        <div class="relative flex flex-0 items-center justify-start w-full h-10 px-6 sm:px-8 z-49 bg-card border-t dark:bg-default print:hidden">
            <span class="font-medium text-secondary">Grupo Tecnología Educativa &copy; {{currentYear}}</span>
        </div>

    </div>

</div>
